import { AccountExternalLink, LinkTypes } from '~/types/AccountExternalLink';
import axios from '~/utils/axios';

export const getAccountExternalLinks = (params: {
  page: number;
  perPage: number;
  accountId: string;
  ids?: string;
}) => {
  return axios.get<AccountExternalLink[]>(`/externalAccountLinks`, { params });
};

export const getAccountExternalLinkById = (id: string) => {
  return axios.get<AccountExternalLink>(`/externalAccountLinks/${id}`);
};

export const createAccountExternalLink = (data: Partial<AccountExternalLink>) => {
  return axios.post<AccountExternalLink>(`/externalAccountLinks`, data);
};

export const updateAccountExternalLink = (id: string, data: Partial<AccountExternalLink>) => {
  return axios.put<AccountExternalLink>(`/externalAccountLinks/${id}`, data);
};

export const deleteAccountExternalLink = (id: string) => {
  return axios.delete(`/externalAccountLinks/${id}`);
};

export const getAccountExternalLinkTypes = () => {
  return axios.get<LinkTypes>(`/externalAccountLinks/linkTypes`).then((res) => res.data);
};
